export default __webpack_public_path__ + "static/media/gun-batım-dogum.00eeb78f.png";